<template>
    <div class="success-view">
        <div class="success-top-title"><p class="font">认证成功</p></div>
        <div class="success-icon"><img src="../assets/img/success.png" alt=""></div>
        <p class="success-text">您的实名认证已成功，请返回引力继续使用。</p>
    </div>
</template>
<style lang="scss">
@import "../assets/css/success.scss";
</style>